<template>
  <el-dialog title="回复用户" :visible.sync="dialogVisible" width="500px" append-to-body>
    <div class="reply-user-container">
      <el-form :model="form" ref="formRef" :rules="rules" label-width="100px">
        <el-form-item label="回复内容：" prop="reply_content">
          <el-input v-model="form.reply_content" type="textarea" :rows="5" placeholder="请输入回复内容" maxlength="300" show-word-limit />
        </el-form-item>
      </el-form>
    </div>


    <div slot="footer" class="dialog-footer">
      <el-button type="default" size="small" @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" size="small" @click="onSubmit">确 认</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { handleZfbComplaintReplayUserApi } from '@/api/merchant_complain_handle';

class DefaultForm {
  constructor () {
    this.id = undefined;
    this.complain_id = undefined;
    this.reply_content = '';
  }
}


export default {
  name: 'ReplyUsers',
  data() {
    const validateReplayContent = (rule, value, callback) => {
      // if (!value) {
      //   callback(new Error('请输入回复内容'));
      // }
      // 至少输入10个字
      if (value.length < 10) {
        callback(new Error('回复内容至少10个字'));
      }
      callback();
    };
    return {
      dialogVisible: false,
      form: new DefaultForm(),
      rules: {
        reply_content: [
          { required: true, message: '请输入回复内容', trigger: 'blur' },
          { validator: validateReplayContent, trigger: 'blur' }
        ]
      }
    };
  },
  methods: {
    triggleVisible (data) {
      this.form.id = data.id || ''
      this.form.complain_id = String(data.complain_id) || ''
      this.dialogVisible = true;
      this.$refs.formRef && this.$refs.formRef.resetFields()
    },


    onSubmit () {
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          console.log('this.form', this.form)
          handleZfbComplaintReplayUserApi(this.form).then(res => {
            if (res.data.code == 200) {
              this.$emit('success')
              this.$message.success('操作成功');
              this.dialogVisible = false
            } else {
              this.$message.error(res.message);
            }
          })
        }
      })
    }
  }
};

</script>